@if (isLoading) {
  <!-- Skeleton Loader -->
  <p-skeleton
    borderRadius="12px"
    width="100%"
    height="316px"
    class="image-skeleton"></p-skeleton>
}

@if (!isLoading) {
  <p-carousel
    [value]="slides"
    [numVisible]="1"
    [numScroll]="1"
    [circular]="slides && slides.length > 1"
    [autoplayInterval]="slides.length > 1 ? 10000 : null">
    <ng-template let-slide pTemplate="item">
      @if (slide.url) {
        <div
          class="image flex-c"
          [style]="{ 'background-image': 'url(' + slide.url + ')' }">
          <div class="image-text">
            <div class="image-title" [title]="slide.title">
              {{ slide.title }}
            </div>
            <div
              class="image-details"
              [title]="slide.subtitle + ' ' + slide.description"
              [innerHtml]="
                slide.subtitle
                  ? '<strong>' +
                    slide.subtitle +
                    '</strong> ' +
                    slide.description
                  : slide.description
              "></div>
          </div>
        </div>
      } @else {
        <app-hero-card-placeholder
          class="hero-card-placeholder"
          [colorHead]="slide.color0"
          [colorShapes]="slide.color70"
          [backgroundColor]="slide.color80">
          <div class="image-text">
            <div class="image-text-title" [style.color]="slide.color0">
              {{ slide.title }}
            </div>
            <div
              class="image-text-description"
              [innerHTML]="
                slide.subtitle
                  ? '<strong>' +
                    slide.subtitle +
                    '</strong> ' +
                    slide.description
                  : slide.description
              "></div>
          </div>
        </app-hero-card-placeholder>
      }
    </ng-template>
  </p-carousel>
}
